<template>
  <view class="calendar-week">
    <view
      class="calendar-week-item"
      wx:for="{{weeks}}"
      wx:key="*this"
      wx:class="{{{'calendar-week-holiday': item === '六' || item === '日'}}}"
    >
      {{ item }}
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
createComponent({
  props: {
    firstDay: {
      type: Number,
      value: 0
    }
  },
  data: {
    weeks: ['日', '一', '二', '三', '四', '五', '六']
  },
  watch: {
    firstDay: {
      immediate: true,
      handler(idx) {
        const week = this.weeks
        this.weeks = [...week.slice(idx), ...week.slice(0, idx)]
      }
    }
  }
})
</script>

<style lang='stylus' scoped>
.calendar-week
  display flex
  line-height 36px
  padding 0 6px
  &-item
    flex 1
    font-size 14px
    text-align center
    font-family PingFangSC-Regular
    color #333
  &-holiday
    color #FF6400
</style>
<script name='json'>
module.exports = {
  component: true
}
</script>

